import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function GadgetsIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M28.2382 9.47264H20.707C19.1791 9.47264 17.9453 10.7093 17.9453 12.2345V28.2382C17.9453 29.7661 19.1818 31 20.707 31H28.2382C29.7661 30.9999 31 29.7634 31 28.2382V12.2344C31 10.7065 29.7633 9.47264 28.2382 9.47264ZM25.4141 13.2382H23.5312C23.0458 13.2382 22.6523 12.8447 22.6523 12.3593C22.6523 11.8739 23.0458 11.4804 23.5312 11.4804H25.4141C25.8995 11.4804 26.293 11.8739 26.293 12.3593C26.293 12.8447 25.8995 13.2382 25.4141 13.2382Z"
        fill="currentColor"
      />
      <path
        d="M10.4141 25.4765H8.46877C7.98338 25.4765 7.58986 25.87 7.58986 26.3554C7.58986 26.8408 7.98338 27.2343 8.46877 27.2343H16.1875V23.3437H10.414V25.4765H10.4141Z"
        fill="currentColor"
      />
      <path
        d="M28.2382 7.71483C28.5389 7.71483 28.8327 7.74501 29.1171 7.80131V3.76169C29.1171 2.2389 27.8782 1 26.3554 1H3.7617C2.23891 1 1 2.23896 1 3.76175V18.8242C1 20.347 2.23891 21.5859 3.7617 21.5859H16.1875V12.2344C16.1875 9.74229 18.215 7.71477 20.707 7.71477L28.2382 7.71483Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
